"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { queryOptions, useQuery } from "@tanstack/react-query";
import { BookX } from "lucide-react";
import { InstructionsWrapper } from "@/components/settings/data-providers/provider-forms/instructions-wrapper";
import { Button } from "@/components/ui/button";
import { CopyableItem } from "@/components/ui/copyable-item";
import { EmptyState } from "@/components/ui/empty-state";
import { FormInput } from "@/components/ui/input";
import { LoadingSpinner } from "@/components/ui/LoadingSpinner";
import { createCondition, WithCondition } from "@/components/ui/with-condition";
import { useCurrentWorkspace } from "@/hooks/useCurrentWorkspace";
import { queryFetcher } from "@/queries/config/query-fetcher";
import { integrationQueryKeys } from "@/queries/query-keys/integrations";
import { ProviderType } from "@/types/dataProvider";
import type { BaseProviderFormProps } from "./base-provider-form";
export type GAdminProviderInstructions = {
  result: {
    details: {
      link: string;
      scope: string;
      clientId: string;
    };
  };
};
type GAdminInstructionsProps = {
  link: string;
  clientId: string;
  scope: string;
  isEditMode?: boolean;
};
const GAdminInstructions = t0 => {
  const $ = _c(17);
  const {
    link,
    clientId,
    scope,
    isEditMode: t1
  } = t0;
  const isEditMode = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== link) {
    t2 = <li>Go to your{" "}<a className="text-primary underline" href={link} rel="noopener noreferrer" target="_blank">Google Admin Portal</a>{" "}and sign in with your super admin email address.</li>;
    $[0] = link;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <li>Click on the "<b>Add new</b>" button to create a new API client for Propstrata.</li>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="block">Copy and paste the following value into the "<b>Client ID</b>" field:{" "}</span>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== clientId) {
    t5 = <li className="space-y-1">{t4}<CopyableItem label="Client ID" value={clientId} /></li>;
    $[4] = clientId;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="block">Copy and paste the following value into the "<b>OAuth scopes</b>" field:{" "}</span>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== scope) {
    t7 = <li className="space-y-1">{t6}<CopyableItem label="OAuth scopes" value={scope} /></li>;
    $[7] = scope;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <li>Click on the "<b>Authorize</b>" button to finalize the process on your Google Admin Portal.</li>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t2 || $[11] !== t5 || $[12] !== t7) {
    t9 = <ol>{t2}{t3}{t5}{t7}{t8}</ol>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== isEditMode || $[15] !== t9) {
    t10 = <InstructionsWrapper accordion={isEditMode}>{t9}</InstructionsWrapper>;
    $[14] = isEditMode;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
export const GAdminProviderForm = t0 => {
  const $ = _c(62);
  const {
    form,
    isCreating,
    currentStep,
    isEditMode: t1
  } = t0;
  const isEditMode = t1 === undefined ? false : t1;
  const {
    workspaceId
  } = useCurrentWorkspace();
  let t2;
  if ($[0] !== workspaceId) {
    t2 = queryOptions({
      queryFn: () => queryFetcher(`/api/workspaces/${workspaceId}/data-provider/fetch-provider-details?providerType=${ProviderType.GADMIN}`, {
        method: "GET"
      }),
      queryKey: integrationQueryKeys.providerInstructions("gadmin"),
      refetchOnMount: true,
      retryOnMount: true
    });
    $[0] = workspaceId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const getProviderInstructionsQuery = t2;
  const {
    data: providerInstructions,
    isLoading: loadingProviderInstructions,
    error,
    refetch
  } = useQuery(getProviderInstructionsQuery);
  let t3;
  if ($[2] !== currentStep || $[3] !== isEditMode) {
    t3 = createCondition.and(createCondition.truthy(currentStep === 0), createCondition.falsy(isEditMode));
    $[2] = currentStep;
    $[3] = isEditMode;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== error) {
    t4 = createCondition.truthy(error);
    $[5] = error;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== refetch) {
    t5 = () => {
      refetch();
    };
    $[7] = refetch;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== loadingProviderInstructions || $[10] !== t5) {
    t6 = <EmptyState className="w-full min-h-[200px]" data-state="error" description="Failed to load provider instructions" icon={BookX} title="Error"><Button disabled={loadingProviderInstructions} onClick={t5} type="button" variant="default">Try again</Button></EmptyState>;
    $[9] = loadingProviderInstructions;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <WithCondition condition={t4}>{t6}</WithCondition>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== loadingProviderInstructions || $[16] !== providerInstructions) {
    t8 = createCondition.and(createCondition.truthy(loadingProviderInstructions), createCondition.truthy(!providerInstructions));
    $[15] = loadingProviderInstructions;
    $[16] = providerInstructions;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <LoadingSpinner className="min-h-[200px]" loadingLabel="Loading provider instructions..." />;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8) {
    t10 = <WithCondition condition={t8}>{t9}</WithCondition>;
    $[19] = t8;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== loadingProviderInstructions || $[22] !== providerInstructions?.result?.details) {
    t11 = createCondition.and(createCondition.truthy(!loadingProviderInstructions), createCondition.truthy(providerInstructions?.result?.details));
    $[21] = loadingProviderInstructions;
    $[22] = providerInstructions?.result?.details;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const t12 = providerInstructions?.result?.details?.clientId || "";
  const t13 = providerInstructions?.result?.details?.link || "";
  const t14 = providerInstructions?.result?.details?.scope || "";
  let t15;
  if ($[24] !== t12 || $[25] !== t13 || $[26] !== t14) {
    t15 = <GAdminInstructions clientId={t12} link={t13} scope={t14} />;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <p className="text-sm">Only click the "<b>Next</b>" button below when you have completed the instructions.</p>;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t15) {
    t17 = <div className="space-y-2">{t15}{t16}</div>;
    $[29] = t15;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t11 || $[32] !== t17) {
    t18 = <WithCondition condition={t11}>{t17}</WithCondition>;
    $[31] = t11;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t10 || $[35] !== t18 || $[36] !== t3 || $[37] !== t7) {
    t19 = <WithCondition condition={t3}>{t7}{t10}{t18}</WithCondition>;
    $[34] = t10;
    $[35] = t18;
    $[36] = t3;
    $[37] = t7;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== currentStep || $[40] !== isEditMode) {
    t20 = createCondition.or(createCondition.truthy(currentStep === 1), createCondition.truthy(isEditMode));
    $[39] = currentStep;
    $[40] = isEditMode;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== isEditMode) {
    t21 = createCondition.truthy(isEditMode);
    $[42] = isEditMode;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  const t22 = providerInstructions?.result?.details?.clientId || "";
  const t23 = providerInstructions?.result?.details?.link || "";
  const t24 = providerInstructions?.result?.details?.scope || "";
  let t25;
  if ($[44] !== isEditMode || $[45] !== t22 || $[46] !== t23 || $[47] !== t24) {
    t25 = <GAdminInstructions clientId={t22} isEditMode={isEditMode} link={t23} scope={t24} />;
    $[44] = isEditMode;
    $[45] = t22;
    $[46] = t23;
    $[47] = t24;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== t21 || $[50] !== t25) {
    t26 = <WithCondition condition={t21}>{t25}</WithCondition>;
    $[49] = t21;
    $[50] = t25;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  let t27;
  if ($[52] !== form || $[53] !== isCreating) {
    t27 = <FormInput autoComplete="off" description="This should be the email address used to add the credentials in the instructions" disabled={isCreating} form={form} label="Email Address" name="data.credentials.superAdminEmail" placeholder="Enter email address" type="email" />;
    $[52] = form;
    $[53] = isCreating;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== t20 || $[56] !== t26 || $[57] !== t27) {
    t28 = <WithCondition condition={t20}>{t26}{t27}</WithCondition>;
    $[55] = t20;
    $[56] = t26;
    $[57] = t27;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  let t29;
  if ($[59] !== t19 || $[60] !== t28) {
    t29 = <>{t19}{t28}</>;
    $[59] = t19;
    $[60] = t28;
    $[61] = t29;
  } else {
    t29 = $[61];
  }
  return t29;
};
(GAdminProviderForm as any).providerType = ProviderType.GADMIN;